export default {
    serviceCategories: 'service Categories',
    serviceCategoriesTitle: 'Title',
    serviceCategoriesStatus: 'status',
    editServiceCategories: 'edit Service Categories',
    addServiceCategories: 'add Service Categories',
    serviceCategoriesType: 'Type',
    serviceCategoriesSubType: 'subType',


    serviceCategoriesLab: 'Lab',
    serviceCategoriesSonography: 'Sonography',
    serviceCategoriesVisit: 'Visit',
    serviceCategoriesSurgery: 'Surgery',
    serviceCategoriesRadiology: 'Radiology',
    serviceCategoriesInjections: 'injections',
    serviceCategoriesConsumables: 'consumables',
    serviceCategoriesContract: 'Contract',


    sonography: 'sonography',
    ovarianUterineAndVaginalSurgeries: 'ovarian Uterine AndVaginal Surgeries',
    menSurgeries: 'men Surgeries',
    infertility: 'infertility',
    lab: 'lab',
    visit: 'visit',
    otherSurgeries: 'other Surgeries',
    eyeSurgery: 'eye Surgery',
    traumaSurgery: 'trauma Surgery',
    breastSurgery: 'breast Surgery',
    generalSurgery: 'general Surgery',
    heartSurgery: 'heart Surgery',
    orthopedicSurgery: 'orthopedic Surgery',
    respiratorySystemSurgery: 'respiratory System Surgery',
    cosmeticSurgery: 'cosmetic Surgery',
    neurologicalSurgery: 'neurological Surgery',
    gastrointestinalSurgeries: 'gastrointestinalSurgeries',
    radiologyMri: 'radiology Mri',
    radiologyCtScan: 'radiology Ct_Scan',
    radiologyMammography: 'Radiology Mammography',


}